import { put, call, takeEvery } from "redux-saga/effects"
import { get } from "lodash"
import { createActions } from "reduxsauce"
import { sendQuery } from "api/graphql"
import { Creators as notificationCreators } from "modules/notifications/model"

export const { Types, Creators } = createActions({
  load: ["resource", "id", "query", "variables", "account", "options", "beta"],
  loadSuccess: ["resource", "id", "data", "apiMessages"],
  loadError: ["resource", "id", "error"],
}, {
  prefix: "ompnt/modules/graphql/",
})

const currentActions = {}

function* loadSaga({ resource, id, query, variables, account, options, beta }) {
  if (id) {
    const uniqueId = resource + id

    // Check if we have an active job loading the same collection and id
    const existingJob = currentActions[uniqueId]

    // Only start the loader if we are not currently loading the same collection and id
    if (!existingJob) {
      currentActions[uniqueId] = true
      try {
        const { data, apiMessages, errors } = yield call(sendQuery, query, variables, account, beta)

        if (errors && errors.length > 0) {
          const code = get(errors, "0.code")
          if (code) {
            yield put(notificationCreators.addApiNotification("error", null, code))
          }
        }

        if (apiMessages.messages && !get(options, "ignoreMessages", false)) {
          const code = get(apiMessages, "messages.0.code")
          if (code) {
            yield put(notificationCreators.addApiNotification("warning", null, code))
          } else {
            yield put(notificationCreators.add("warning", null, get(apiMessages, "messages.0.message")))
          }
        }

        yield put(Creators.loadSuccess(resource, id, data, apiMessages))
      } catch (error) {
        yield put(Creators.loadError(resource, id, error))
      } finally {
        // clears the key in the jobs lookup
        delete currentActions[uniqueId]
      }
    }
  }
}

export function* saga() {
  yield takeEvery(Types.LOAD, loadSaga)
}
